import { message } from "antd";
import { axiosInstant } from "../../api/api";

// A candidate who opens a shared job link is usually not signed up yet, so the
// job they clicked is parked here while they go through OAuth and pick their
// role, and the application is created once they come back as a candidate.
const PENDING_JOB_APPLICATION_KEY = "pendingJobApplication";

export const setPendingJobApplication = (jobId: string) =>
  localStorage.setItem(PENDING_JOB_APPLICATION_KEY, jobId);

export const getPendingJobApplication = () =>
  localStorage.getItem(PENDING_JOB_APPLICATION_KEY);

export const clearPendingJobApplication = () =>
  localStorage.removeItem(PENDING_JOB_APPLICATION_KEY);

/**
 * Creates the parked job application for a freshly signed-up candidate, so the
 * job shows up as pending on their dashboard. Safe to call when nothing is
 * parked - it resolves to false without touching the API.
 */
export const consumePendingJobApplication = async (
  candidateId: string
): Promise<boolean> => {
  const jobId = getPendingJobApplication();
  if (!jobId || !candidateId) return false;

  // Cleared up front: whether the apply call succeeds or fails, it must not be
  // replayed on the next sign-in.
  clearPendingJobApplication();

  try {
    await axiosInstant.post("/job-applications/apply", { jobId, candidateId });
    message.success(
      "Job added to your applications! Please complete your profile and answer screening questions to submit."
    );
    return true;
  } catch (error: any) {
    console.error("Failed to create pending job application:", error);
    const reason = error?.response?.data?.message;
    if (error?.response?.status === 409 || /already applied/i.test(reason || "")) {
      message.warning("You have already applied for this job!");
    } else {
      message.error(reason || "Failed to add the job to your applications.");
    }
    return false;
  }
};
